module.exports = __webpack_public_path__ + "static/media/taipei.6fa23ca2.png";